import { z } from "zod";
import {
  DEAL_CLOSURE_DATE,
  DEAL_AMOUNT,
  INCLUDES_GST,
  PDCS_COLLECTED,
  SALES_PERSON_TYPE,
  DEAL_CLOSED_BY,
  LEAD_TYPE,
  CONTRACT_YEARS,
  PAYMENT_FROM_ENTITY,
  EXPECTED_LAUNCH_DATE,
  AGREEMENT_DOCUMENT,
  INSTALLMENT_YEAR,
  INSTALLMENT_NUMBER,
  EXPECTED_DUE_DATE,
  INSTALLMENT_AMOUNT,
  INSTALLMENT,
  MOU_AMOUNT,
  INTEREST_PERCENTAGE,
} from "./consts";

export const schema = z.object({
  [DEAL_CLOSURE_DATE]: z.string().optional(),
  [DEAL_AMOUNT]: z.string().optional(),
  [INCLUDES_GST]: z.string().min(1, "This field is required"),
  [PDCS_COLLECTED]: z.string().min(1, "This field is required"),
  [SALES_PERSON_TYPE]: z.string().min(1, "This field is required"),
  [DEAL_CLOSED_BY]: z.string().min(1, "This field is required"),
  [LEAD_TYPE]: z.string().min(1, "This field is required"),
  [CONTRACT_YEARS]: z.string().min(1, "This field is required"),
  [PAYMENT_FROM_ENTITY]: z.string().min(1, "This field is required"),
  [EXPECTED_LAUNCH_DATE]: z.string().optional(),
  [AGREEMENT_DOCUMENT]: z
    .any()
    .refine((val) => val != null && val !== undefined && val !== "", {
      message: "This field is required",
    }),
  // Installments
  [INSTALLMENT]: z
    .object({
      _id: z.string().optional(),
      [INSTALLMENT_YEAR]: z.string().min(1, "This field is required"),
      [INSTALLMENT_NUMBER]: z.string().min(1, "This field is required"),
      [EXPECTED_DUE_DATE]: z.string().min(1, "This field is required"),
      [INSTALLMENT_AMOUNT]: z.string().min(1, "This field is required"),
      [MOU_AMOUNT]: z.string().min(1, "This field is required"),
      [INTEREST_PERCENTAGE]: z.string().min(1, "This field is required"),
      pdcData: z
        .array(
          z.object({
            year: z.number(),
            pdcNumber: z.number(),
            pdcDate: z.string(),
            pdcAmount: z.number(),
            pdcRemarks: z.string().optional().nullable(),
          })
        )
        .optional(),
    })
    .array(),
});


export const InstallmentSchema = z.object({

      "_id": z.string().optional(),
      [INSTALLMENT_YEAR]: z.string().min(1, "This field is required"),
      [INSTALLMENT_NUMBER]: z.string().min(1, "This field is required"),
      [EXPECTED_DUE_DATE]: z.string().min(1, "This field is required"),
      [INSTALLMENT_AMOUNT]: z.string().min(1, "This field is required"),
      [MOU_AMOUNT]: z.string().min(1, "This field is required"),
      [INTEREST_PERCENTAGE]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
export type installmentFormValues = z.infer<typeof InstallmentSchema>;
